<p-multiSelect class="w-100 w-md-50"
  [options]="dropdownOptions"
  [defaultLabel]="placeholder"
  [(ngModel)]="selectedDropdownOptions"
  optionLabel="name"
  (onChange)="onChangeSelection()"
  [filter]="filter"
  [display]="display">
</p-multiSelect>
